import type { NoticeProduct } from "../api/types";
import type { ProductPolicyLink } from "../types";

export const getProductPolicyLinks = (
  products: ReadonlyArray<NoticeProduct> | null | undefined,
  policies: Record<string, string> | null | undefined
): ProductPolicyLink[] => {
  if (!policies) {
    return [];
  }
  return (products ?? []).flatMap((product) => {
    const url = policies[product.uuid];
    return url ? [{ uuid: product.uuid, name: product.name, url }] : [];
  });
};

export const shouldShowNoticePolicyLink = (
  products: ReadonlyArray<NoticeProduct> | null | undefined,
  links: ReadonlyArray<ProductPolicyLink>
): boolean => {
  const productCount = products?.length ?? 0;
  if (links.length === 0 || productCount === 0) {
    return true;
  }
  return links.length < productCount;
};
